import React, { useContext } from 'react';

import { FormCrawlTableContext } from '../FormCrawlRuleTable';
import { VARIABLE_OPERATORS_TRIGGERS } from '../../../../../../../../constants';
import CLabel from '../../../../../../../migration/CLabel';
import { CSelect } from '../../../../../../../migration/CInput';
import CTooltip from '../../../../../../../migration/CTooltip';

const TableHeaderRow = () => {
     const { conditions, handleSelectOperator } = useContext(FormCrawlTableContext);

     const eventKey = (key) => {
          return (
               <CTooltip content={key} placement="top" advancedOptions={{ delay: { hide: 0 } }}>
                    <span>{key}</span>
               </CTooltip>
          );
     };

     return (
          <>
               <tr className="table-header">
                    {conditions?.[0].map((condition, index) => {
                         const { conjunction } = condition;
                         const conditionValues = condition.g0;
                         const { type, operator, key } = conditionValues;

                         return (
                              <td key={index} className={operator === null ? `no-condition variable-header` : `has-condition variable-header`}>
                                   <CLabel>{type}</CLabel>
                                   {eventKey(key)}
                                   {index < conditions[0].length - 1 && (
                                        <CSelect
                                             name="conjunction"
                                             className="conditions"
                                             value={conjunction || 'and'}
                                             onChange={(e) => handleSelectOperator(e, index)}
                                             disabled
                                        >
                                             <option value="and">and</option>
                                             <option value="or">or</option>
                                        </CSelect>
                                   )}
                              </td>
                         );
                    })}
               </tr>
               <tr className="table-body conditions-row">
                    {conditions?.[0].map((condition, index) => {
                         const conditionValues = condition.g0;
                         let { operator, key } = conditionValues;
                         let isDisableSelect = false;

                         if (key === 'Match Type') {
                              operator = 'eq'
                              isDisableSelect = true;
                         }

                         return (
                              <td key={index}>
                                   <CSelect
                                        name="operator"
                                        className="variable-conditions rounded-0"
                                        value={operator}
                                        disabled={isDisableSelect}
                                        onChange={(e) => handleSelectOperator(e, index)}
                                   >
                                        <option value="" disabled hidden>
                                             Select
                                        </option>
                                        {VARIABLE_OPERATORS_TRIGGERS.map(({ VALUE, TEXT }) => (
                                             <option key={VALUE} value={VALUE}>
                                                  {TEXT}
                                             </option>
                                        ))}
                                   </CSelect>
                              </td>
                         );
                    })}
               </tr>
          </>
     );
};

export default TableHeaderRow;
